import './_collection-hatbox-grid.scss';
import component from './collection-hatbox-grid';

export default component;
